import {ReactNode} from 'react';
import {ErrorBoundary} from '@sail/observability';
import AppError from 'src/components/core/AppError';
import {useLogger} from 'src/utils/logger';
import {logErrorToSentry} from 'src/v2/util/sentryLogger';

type Props = {
  children: ReactNode;
  uuid: string;
};

export const PayinsErrorBoundary = ({children, uuid}: Props) => {
  const logger = useLogger();

  const logError = (error: Error) => {
    // We failed to handle an error gracefully! Report to Sentry.
    logErrorToSentry(error, 'unknown', 'unknown_error');

    logger.log('crypto_payin_session.render.error', {
      error_message: error.message,
    });
  };

  return (
    <ErrorBoundary
      uuid={`${uuid}-8NN9TQ00`}
      errorView={AppError}
      onError={logError}
    >
      {children}
    </ErrorBoundary>
  );
};
